import { Injectable } from '@angular/core';
import { RemoteLoggerAdapter } from 'src/app/adapters/remote-logger/remote-logger.adapter';
import {
  MSRemoteLoggerCategory,
  MSRemoteLoggerData,
  MSRemoteLoggerSeverity
} from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Injectable({
  providedIn: 'root'
})
export class RemoteLoggerUseCase {
  constructor(private remoteLoggerAdapter: RemoteLoggerAdapter) {}

  setUserProperty(property: MSRemoteLoggerData) {
    this.remoteLoggerAdapter.setUserProperty(property);
  }

  setGlobalAttributes(attributes: MSRemoteLoggerData) {
    this.remoteLoggerAdapter.setGlobalAttributes(attributes);
  }

  addBreadcrumbs(message: string, category: MSRemoteLoggerCategory, level: MSRemoteLoggerSeverity, data?: MSRemoteLoggerData) {
    this.remoteLoggerAdapter.addBreadcrumbs(message, category, level, data);
  }

  captureException(exception: Error) {
    this.remoteLoggerAdapter.captureException(exception);
  }

  setTag(key: string, value: string) {
    this.remoteLoggerAdapter.setTag(key, value);
  }

  log(message: string, category: MSRemoteLoggerCategory, level: MSRemoteLoggerSeverity, data?: any): void {
    this.remoteLoggerAdapter.log(message, category, level, data);
  }
}
